import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NDCOrderManagementCapabilitiesPage } from 'src/app/model/page/ndc-order-management-capabilities-page';
import { Section } from 'src/app/model/shared/section';
import { TabMenu } from 'src/app/model/shared/tab-menu';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-order-management-capabilities-page',
  templateUrl: './ndc-order-management-capabilities-page.component.html',
  styleUrls: ['./ndc-order-management-capabilities-page.component.scss']
})
export class NDCOrderManagementCapabilitiesPageComponent implements OnInit {
  tabMenu: TabMenu = {} as TabMenu;
  sectionsMap = new Map();
  selectedIndex: number = 0;
  pageName = 'NDC Order Management Capabilities';
  ndcOrderManagementCapabilitiesPage: NDCOrderManagementCapabilitiesPage = {} as NDCOrderManagementCapabilitiesPage;

  OfferManagementTitle: string = '';
  OfferManagementLink: string = '';
  linkTextSeperator: string = '';
  OrderManagementTitle: string = '';
  OrderManagementLink: string = '';

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'order-management-capabilities') {
        this.ndcOrderManagementCapabilitiesPage.htmlTitle = title.htmlTitle;
      }
    });
    const menuQuery = { 'fields.name': 'Tab Menu#Order Management' };
    this.contentfulService.getMenuContentWithItems(menuQuery).then((menuItems) => {
      this.tabMenu.links = menuItems[0]?.fields.jsonData;
    });

    const pageQuery = { 'fields.title': this.pageName };
    this.ndcOrderManagementCapabilitiesPage.sections = [];
    this.contentfulService.getPageContentWithEntries(pageQuery).then((ndcOrderManagementCapabilities) => {
      this.mapBanner(ndcOrderManagementCapabilities);
      this.mapSections(ndcOrderManagementCapabilities);
      this.mapLinkNavigationDetails();
    });
    this.contentfulService.getPageContentWithItems(pageQuery).then((ndcOrderManagementCapabilities) => {
      ndcOrderManagementCapabilities.forEach((entry: any) => {
        this.ndcOrderManagementCapabilitiesPage.htmlTitle = entry.fields.htmlTitle;
      });
    });
  }

  private mapSections(ndcOrderManagementCapabilities: Entry<any>[]) {
    ndcOrderManagementCapabilities
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    let sectionArray: Section[] = [];

    this.ndcOrderManagementCapabilitiesPage.sections.filter((section) => {
      const key = section.group.split('#').pop();
      sectionArray = this.sectionsMap.get(key);
      // // console.log(sectionArray);
      if (sectionArray === undefined || sectionArray.length == 0) {
        sectionArray = [];
      }
      sectionArray.push(section);
      sectionArray.sort((a, b) => a.order - b.order);
      this.sectionsMap.set(key, sectionArray);
    });

    // console.log(this.sectionsMap);
  }

  private mapBanner(ndcoffermanagementcapabilities: Entry<any>[]) {
    ndcoffermanagementcapabilities
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#')[2];

    this.ndcOrderManagementCapabilitiesPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      subBody: entry.fields['subBody'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.ndcOrderManagementCapabilitiesPage.banner = {
      title:  entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: ''
    };
  }

  private mapLinkNavigationDetails() {
    const query = { 'fields.title': 'NDC Offer Management Capabilities' };
    this.contentfulService.getPageContentWithItems(query).then((labelItems) => {
      this.OfferManagementTitle = labelItems[0]?.fields.constants[0].OfferManagementTitle;
      this.OfferManagementLink = labelItems[0]?.fields.constants[0].OfferManagementLink;
      this.linkTextSeperator = labelItems[0]?.fields.constants[0].linkTextSeperator;
      this.OrderManagementTitle = labelItems[0]?.fields.constants[0].OrderManagementTitle;
      this.OrderManagementLink = labelItems[0]?.fields.constants[0].OrderManagementLink;
      // console.log('labelItems', labelItems);
    });
  }
}
